function isWindow(val) {
    return val === window;
}

var overflowScrollReg = /scroll|auto/i;
export function getScroller(el) {
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
    var node = el;

    while (node && node.tagName !== 'HTML' && node.nodeType === 1 && node !== root) {
        var _window$getComputedSt = window.getComputedStyle(node),
            overflowY = _window$getComputedSt.overflowY;

        if (overflowScrollReg.test(overflowY)) {
            if (node.tagName !== 'BODY') {
                return node;
            }

            var _window$getComputedSt2 = window.getComputedStyle(node.parentNode),
                htmlOverflowY = _window$getComputedSt2.overflowY;

            if (overflowScrollReg.test(htmlOverflowY)) {
                return node;
            }
        }

        node = node.parentNode;
    }

    return root;
}
export function getScrollTop(el) {
    return 'scrollTop' in el ? el.scrollTop : el.pageYOffset;
}
export function setScrollTop(el, value) {
    if ('scrollTop' in el) {
        el.scrollTop = value;
    } else {
        el.scrollTo(el.scrollX, value);
    }
}
export function getRootScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}
export function setRootScrollTop(value) {
    setScrollTop(window, value);
    setScrollTop(document.body, value);
}
export function getElementTop(el, scroller) {
    if (isWindow(el)) {
        return 0;
    }

    var scrollTop = scroller ? getScrollTop(scroller) : getRootScrollTop();
    return el.getBoundingClientRect().top + scrollTop;
}
export function getVisibleHeight(el) {
    if (isWindow(el)) {
        return el.innerHeight;
    }

    return el.getBoundingClientRect().height;
}
export function getVisibleTop(el) {
    if (isWindow(el)) {
        return 0;
    }

    return el.getBoundingClientRect().top;
}
export function removeNode(el) {
    var parent = el.parentNode;

    if (parent) {
        parent.removeChild(el);
    }
}
